import { render, staticRenderFns } from "./DefaultTask.vue?vue&type=template&id=a79ab41c&scoped=true&"
import script from "./DefaultTask.vue?vue&type=script&lang=js&"
export * from "./DefaultTask.vue?vue&type=script&lang=js&"
import style0 from "./DefaultTask.vue?vue&type=style&index=0&id=a79ab41c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79ab41c",
  null
  
)

export default component.exports